<template>
  <div class="d-flex justify-center actions-bar">
    <NewApprovalChainTemplateDialog @close="closeDialog" :isOpen="isOpen" />
    <SecondaryButton
      @click.native="openDialog"
      permission="create"
      color="primary"
    >
      <div class="d-flex align-center justify-center">
        <v-icon>mdi-playlist-check</v-icon>
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Approval Chain
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewApprovalChainTemplateDialog from "@/views/settings/components/approval-chain-templates/components/dialogs/NewApprovalChainTemplateDialog";

export default {
  components: {
    NewApprovalChainTemplateDialog,
    SecondaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
